import i18next from 'i18next';

/** Evaluate the current language on each call, including after an in-session language change. */
export function getLanguageDirection(language: string): 'ltr' | 'rtl' {
  return i18next.dir((language.trim() || 'en').replaceAll('_', '-'));
}
